import { useEffect, useRef } from "react"

const useInactivityTimer = (
    onInactive: () => void,
    timeoutMs: number = 180000
) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const resetTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            onInactive();
        }, timeoutMs);
    };

    useEffect(() => {
        const events = [
            'mousedown',
            'mousemove',
            'keypress',
            'scroll',
            'touchstart',
            'click',
        ];

        resetTimer();

        events.forEach(event => {
            document.addEventListener(event, resetTimer);
        });

        return () => {
            events.forEach(event => {
                document.removeEventListener(event, resetTimer);
            });
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [timeoutMs]);

    return { resetTimer }
}

export default useInactivityTimer;